import React, { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import storage from "../../Assets/js/Global";
import SignupProgress from "../../Components/SignupProgress";
import { images } from "../../Assets/images";

const ResetPassword = () => {
  const {
    userData,
    showPasswords,
    togglePassword,
    signupData,
    updateSignupData,
    completeSignup,
    translatedLabels,
    resetPassword,
    updateUserData,
    logoUrl,
    is4Life,
  } = useContext(GlobalContext);
  const userModule = storage.get("UserModule");
  const authLabel = translatedLabels?.auth;

  const isForgetPassword = userModule === "ForgetPassword";

  const passwordValue = isForgetPassword
    ? userData.setPassword
    : signupData?.password;
  const confirmPasswordValue = isForgetPassword
    ? userData.confirmPassword
    : signupData?.confirmPassword;

  const handlePasswordChange = (e) =>
    isForgetPassword
      ? updateUserData("setPassword", e.target.value)
      : updateSignupData("password", e.target.value);

  const handleConfirmPasswordChange = (e) =>
    isForgetPassword
      ? updateUserData("confirmPassword", e.target.value)
      : updateSignupData("confirmPassword", e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isForgetPassword) {
      resetPassword();
    } else {
      completeSignup();
    }
  };

  return (
    <>
      <section id="resetPasswordPage" className="login-section-bg">
        <div className="container-main">
          <div className="text-center">
            <div className="d-flex justify-content-center">
              <div className="app-logo">
                <img
                  src={logoUrl || images.appLogo}
                  alt="app-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = images.appLogo;
                  }}
                />
              </div>
            </div>
          </div>
          {userModule === "setPassword" ? (
            <SignupProgress currentStep={is4Life ? null : 4} />
          ) : (
            ""
          )}
          <h3 className="my-2 text-center">
            {userModule === "setPassword"
              ? authLabel?.set_password?.label_value || "Set Password"
              : authLabel?.change_password?.label_value || "Reset Password"}
          </h3>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group mb-2">
              <div className="position-relative">
                <label className="form-label">
                  {authLabel?.create_password?.label_value || "Create Password"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type={showPasswords.field1 ? "text" : "password"}
                  name="password1"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_password?.label_value || "Enter Password"
                  }
                  required
                  value={passwordValue}
                  onChange={handlePasswordChange}
                />
                <span
                  className="toggle-password position-absolute eye-icon"
                  onClick={() => togglePassword("field1")}
                >
                  <i
                    className={`fa ${
                      showPasswords.field1 ? "fa-eye" : "fa-eye-slash"
                    }`}
                  ></i>
                </span>
              </div>
            </div>

            <div className="form-group mb-2">
              <div className="position-relative">
                <label className="form-label">
                  {authLabel?.confirm_password?.label_value ||
                    "Confirm Password"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type={showPasswords.field2 ? "text" : "password"}
                  name="password2"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_password?.label_value || "Enter Password"
                  }
                  required
                  value={confirmPasswordValue}
                  onChange={handleConfirmPasswordChange}
                />
                <span
                  className="toggle-password position-absolute eye-icon"
                  onClick={() => togglePassword("field2")}
                >
                  <i
                    className={`fa ${
                      showPasswords.field2 ? "fa-eye" : "fa-eye-slash"
                    }`}
                  ></i>
                </span>
              </div>
            </div>

            <br />
            <div className="mt-3 text-center">
              <button
                type="button"
                onClick={isForgetPassword ? resetPassword : completeSignup}
                className="btn btn-primary"
              >
                {authLabel?.submit?.label_value || "Submit"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default ResetPassword;
